import "./SearchBar.scss";

import React, { useMemo, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchList from "./SearchList";
import { debounce } from "lodash";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { useTranslation } from "react-i18next";
import { useAllProducts } from "../../hooks/useAllProducts";

export default function SearchBar() {
    const { t } = useTranslation("layout");
    const [searchString, setSearchString] = useState("");
    const [localSearchString, setLocalSearchString] = useState(searchString);
    const { navigateTranslated } = usePageLocalization();

    const allProducts = useAllProducts();

    const [isDropdowOpen, setDropdownOpen] = useState(false);
    const searchTermsDelay = useMemo(() => debounce(setSearchString, 1000), []);
    return (
        <div className="search-bar">
            <div className="search-input">
                <input
                    className="input"
                    key={"search-input-text-box"}
                    value={localSearchString}
                    onChange={(event) => {
                        setLocalSearchString(event.target.value);
                        if (event.target.value.length > 2) {
                            searchTermsDelay(event.target.value);
                        }
                        if (!isDropdowOpen && searchString.length >= 2) setDropdownOpen(true);
                    }}
                    onClick={() => {
                        if (!isDropdowOpen && searchString.length >= 2) setDropdownOpen(true);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" && localSearchString.trim() !== "")
                            navigateTranslated(`/search/?q=${localSearchString}`);
                    }}
                    onBlur={() => {
                        setTimeout(() => {
                            if (isDropdowOpen) {
                                setDropdownOpen(false);
                            }
                        }, 1000);
                    }}
                    placeholder={t("header.search-placeholder") as string}
                />
                <FontAwesomeIcon
                    className="icon"
                    icon={faSearch}
                    onClick={() =>
                        localSearchString.trim() !== "" &&
                        navigateTranslated(`/search/?q=${localSearchString}`)
                    }
                />
            </div>

            <SearchList
                searchString={searchString}
                allProducts={allProducts}
                isSearchListOpen={isDropdowOpen}
                t={t}
                setSearchListOpen={setDropdownOpen}
            />
        </div>
    );
}
